import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Calculator, BookOpen, ArrowRight } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const LINKS = [
  { to: '/', label: 'Go to Homepage', icon: Home },
  { to: '/calculators', label: 'Financial Calculators', icon: Calculator },
  { to: '/insights', label: 'Capital Insights', icon: BookOpen }
];

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'Page Not Found | LOANYARD CAPITAL';
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute('content', 'noindex, follow');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-36 pb-24" data-testid="not-found-page">
        <div className="container mx-auto px-4 max-w-2xl text-center">
          <p className="text-7xl font-bold text-emerald-600 mb-4">404</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">Page not found</h1>
          <p className="text-base text-slate-600 leading-relaxed mb-10">
            The page you are looking for does not exist or may have moved. Explore our capital solutions, calculators and insights below.
          </p>
          <div className="grid sm:grid-cols-3 gap-4 mb-10">
            {LINKS.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                data-testid={`notfound-link-${to === '/' ? 'home' : to.slice(1)}`}
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg border border-slate-200 text-slate-700 hover:border-emerald-500 hover:text-emerald-700 transition-colors text-sm font-medium"
              >
                <Icon className="w-4 h-4" />
                {label}
              </Link>
            ))}
          </div>
          <Link
            to="/#contact"
            data-testid="notfound-contact-link"
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Discuss Your Requirement
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
